var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "matrix(1 0 0 -1 15.5 24.5)",
    d: "M10.765594 1.2994534L6.0155935 5.7713284C5.8718433 5.9338279 5.6843433 6.0025783 5.4999685 6.0025783C5.3155937 6.0025783 5.1287184 5.9342036 4.9843435 5.7975154L0.23434351 1.2994534C-0.066594139 1.0119535 -0.079093948 0.53695357 0.20496844 0.23695335C0.49028111 -0.066172034 0.96684361 -0.075546652 1.2655935 0.20882854L5.4999685 4.2182031L9.7343435 0.20570335C10.033156 -0.078483969 10.507781 -0.067734152 10.794969 0.23500022C11.078094 0.53695357 11.065594 1.0119535 10.765594 1.2994534Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.aa0adb97255f3bea2f79c3702475b067.svg";
export { ForwardRef as ReactComponent };